import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface MyVerifiedProfilesResponse extends BackendResponse {
  /** Active profiles for this IdpUser — candidates reachable via a verified email link. */
  verifiedProfiles: Profile[];
  /** SUGGESTIONS ONLY. Candidates previously associated with this IdpUser
   * (CvpUserActiveProfile + legacy AccountLink) that are no longer in
   * `verifiedProfiles`. Use to *offer* reconnection of orphaned accounts.
   * Showing a profile here does NOT grant access to it — the user must
   * verify ownership of the candidate's email (sendOtc + markEmailVerified)
   * before any session can be issued for it. */
  profileHistory: Profile[];
}

export interface MyVerifiedProfilesParameters extends NextApiParams {}

export const myVerifiedProfiles = withNextApi<
  MyVerifiedProfilesResponse,
  MyVerifiedProfilesParameters
>("/auth/MyVerifiedProfiles", {
  method: "GET",
});

export interface Profile {
  idpUserId: string;
  candidateId: number;
  concernId: number;
  concernName: string;
  lastUsedAt?: string | null;
  candidateEmail?: string | null;
  isEmailVerified: boolean;
  profileType: "VerifiedProfile" | "History_UnverifiedProfile";
  /** For History_UnverifiedProfile entries: why the candidate surfaced in the
   *  history list. See DbProvider.IdpUserCandidateHistory. Debug / tooltip
   *  use only — do NOT use as an authorization signal. */
  associatedReason?:
    | "ActiveProfile"
    | "AccountLinkCurrentEmail"
    | "AccountLinkVerifiedEmail"
    | "AccountLinkGuid"
    | null;
}
